<template>
  <div>
    <h3 class="page-title"> 素材管理 </h3>
    <h4 class="breadcrumb-c">
      <router-link :to="{name: 'material', query: {
                      type: 3
                  }}" class="back-btn">
        <i class="fa fa-angle-left"></i> 视频 </a>
      </router-link> / 添加视频</h4>

    <form class="form-horizontal form" role="form">
      <div class="form-body">
        <div class="form-group">
          <label class="control-label col-sm-3">
            <span class="required">*</span>上传视频
            <!--<span class="required"> * </span>-->
          </label>
          <div class="col-sm-8">
            <p class="form-control-static" style="display:block;color:#888888;">视频不能超过10M，建议时长3分钟左右，仅支持MP4格式</p>
            <c-file-upload :config.sync="content"></c-file-upload>
          </div>
        </div>

        <div class="form-group">
          <label class="col-sm-3 control-label">标题</label>
          <div class="col-sm-5">
            <input class="form-control" v-model="title" maxlength="24" v-maxlength />
          </div>
        </div>

        <div class="form-group">
          <label class="control-label col-sm-3">
            <span class="required">*</span>封面
            <!--<span class="required"> * </span>-->
          </label>
          <div class="col-sm-8">
            <c-file-upload :config.sync="cover"></c-file-upload>
          </div>
        </div>

        <div class="form-group">
          <label class="col-sm-3 control-label">分组</label>
          <div class="col-sm-8">
            <select class="form-control" v-model="gid" style="width:auto;">
              <option value="ungroup">未分组</option>
              <template v-for="g in groups">
                <option :value="g.objectId">{{g.title}}</option>
              </template>
            </select>
          </div>
        </div>

        <div class="form-group">
          <label class="col-sm-3 control-label" style="vertical-align:top">简介</label>
          <div class="col-sm-8">
            <textarea class="form-control" rows="3" v-model="about" maxlength="1000" v-maxlength></textarea>
          </div>
        </div>
        <div class="form-group" style="margin-bottom:0;">
          <!--<label class="col-sm-3 control-label"></label>-->
          <div class="col-sm-12" style="text-align: center">
            <p class="form-control-static" style="color:#888;"> 不得上传未经授权的他人作品，以及色情、反动等违法视频。
              <!--<a href="javascript:void(0);" class="btn" data-container="body"
  data-trigger="hover" data-placement="top" data-content="1.上传：将视频上传至服务器，需视频和文案资料完成才能完成上传。
                          2.转码：上传成功后服务器将视频转码成播放器可识别的格式。
                          3.审核：转码完成后视频进入内容审核阶段。
                          4.可用：只有审核通过的视频素材才可以被使用" data-original-title="流程">查看视频处理流程。</a>-->
            </p>
          </div>
        </div>
        <div class="form-group">
          <!--<label class="col-sm-3 control-label"></label>-->
          <div class="col-sm-12">
            <div class="checkbox-list" style="text-align: center">
              <label class="checkbox-inline">
                <!-- <div class="checker">
                  <span class="checked"
                    ><input type="checkbox" data-enpassusermodified="yes"
                  /></span>
                </div> -->
                <!-- <input type="checkbox" v-model="agreeRule"> -->
                 我已同意并阅读
                <a href="/web-mgr/media/agreement" target="_blank" style="color:#4a90e2">《视网么音视频上传规则》</a>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="form-actions">
        <div class="row">
          <div class="col-sm-12" style="text-align: center">
            <!--col-sm-offset-3 -->
            <button type="button" class="btn m-green" @click="submit()">保存</button>
            <!--<button type="button" class="btn grey-salsa btn-outline" @click="back()">取消</button>-->
          </div>
        </div>
      </div>
    </form>
  </div>
</template>


<script type="text/javascript">

import $ from 'jquery';

import { mapState, mapActions } from 'vuex';

import cFileUpload from '../../components/fileupload';

export default {

  data() {
    return {
      title: '',
      about: '',
      agreeRule: false,
      gid: localStorage.getItem('group') || 'ungroup',
      cover: {
        nolocal: true,
        space: 'image',
        type: 'image',
        accept: '.jpg,.png,.jpeg',
        name: 'file',
        fileName: null,
        file: null,
        imgId: null
      },
      content: {
        type: 'video',
        accept: '.mp4',
        name: 'content',
        fileName: null,
        file: null
      }
    }
  },
  components: {
    cFileUpload
  },
  computed: mapState([
    'groups'
  ]),
  watch: {
    'content.fileName'(val) {

      this.title = val;
      if (val) {
        let idx = val.lastIndexOf('.');

        if (idx > 0) {
          this.title = val.substr(0, idx);
        }
      }
    }
  },
  methods: {
    ...mapActions([
      'toast',
      'showAlert',
      'showConfirm',
      'showLoading',
      'hideLoading',
      'showSelectImgWin',
      'showSelectVideoWin',
      'showPlayer',
      'hidePlayer',
      'saveVideoTime'
    ]),
    submit() {
      let self = this;

      // if (!this.agreeRule) {
      //   this.showAlert('请同意我们的视频上传规则。');
      //   return;
      // }

      if (!this.cover.imgId) {
        this.showAlert('视频封面不能为空！');
        return;
      }

      if (!this.content.fileName) {
        this.showAlert('视频文件不能为空！');
        return;
      }

      if (this.content.file && this.content.file[0]
        && this.content.file[0].files
        && this.content.file[0].files.length > 0) {

        let fileName = this.content.fileName;
        if (fileName && fileName.substr(fileName.lastIndexOf('.')) != '.mp4') {
          self.showAlert('视频文件格式不正确，目前只支持mp4文件格式！');
          return;
        }

        if (this.content.file[0].files[0].size > 100 * 1024 * 1024) {
          self.showAlert('视频文件最大支持10M，请确认文件大小！');
          return;
        }

      }

      this.showLoading('提交中，请稍后。。。');

      $.ajaxFileUpload({
        url: '/api/web/material/video/add',
        secureuri: false,
        timeout: 1000 * 60,
        fileElementId: $(self.content.file),
        data: {
          title: self.title,
          coverId: self.cover.imgId,
          about: self.about,
          gid: self.gid
        },
        dataType: 'json',
        success: function(data, status) {

          self.hideLoading();
          if (data.code == 200) {
            self.toast('恭喜您，添加成功！');

            self.saveVideoTime({
              url: data.data.content.url,
              id: data.data.objectId,
              type: 'video'
            });

            self.back();
          } else {
            self.showAlert((data && data.message) || '操作失败，请稍后再试！');
            self.back();
          }
        },
        error: function(data, status, e) {
          self.showAlert('操作失败，请稍后再试！');
          self.back()
        }
      });
    },
    back() {
      this.$router.push({
        name: 'material', query: {
          type: 3
        }, replace: true
      });
      /*this.$route.router.go({
          path: '/web-mgr/material?type=3',
          replace: true
      });*/
    }
  }
}
</script>
